import { Components, Theme } from '@mui/material'

export const MuiAppBar: Components<Omit<Theme, 'components'>>['MuiAppBar'] = {
  defaultProps: {
    color: 'inherit',
    elevation: 0,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      height: 51,

      color: theme.palette.text.default,
      backgroundColor: theme.palette.bg.surface.subtle,

      border: 0,
      borderBottomWidth: theme.strokeWidth.default,
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.border.strong,

      boxShadow: 'none',
      justifyContent: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        paddingLeft: '30px',
        paddingRight: 0,
      },
    }),
  },
}
